import { TextField, MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const LevelSelector = () => {
  const levelArray = Array.from({ length: 10 }, (_, i) => i + 1);
  const navigate = useNavigate();

  const handleChange = e => {
    if (e.target.value !== '') navigate('/manage/classes/' + e.target.value);
  };
  return (
    <>
      <TextField
        label='Select Level'
        fullWidth
        select
        defaultValue=''
        onChange={handleChange}
        id='level-selector'
      >
        <MenuItem value=''>&nbsp;</MenuItem>
        {levelArray.map(levelId => {
          return (
            <MenuItem key={levelId} value={levelId}>
              Level {levelId}
            </MenuItem>
          );
        })}
      </TextField>
    </>
  );
};

export default LevelSelector;
